import React, { useEffect, useRef } from "react";
import { t } from "i18next";

import { PositionXType, PositionYType, TextAlignType } from "../../../interfaces/types";

import Typography from "../../shared/typography/Typography";

import { Container, Input, TextLenght, Wrapper } from "./style";

interface IProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  maxLength?: number;
  textAlign?: TextAlignType;
  positionX?: PositionXType;
  positionY?: PositionYType;
}

export const TextArea = ({onChange, value, maxLength, placeholder, textAlign, positionX, positionY}: IProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textAreaRef.current && wrapperRef.current) {
      textAreaRef.current.style.height = "0px";
      const scrollHeight = textAreaRef.current.scrollHeight;
      textAreaRef.current.style.height = scrollHeight + "px";
      wrapperRef.current.style.height = scrollHeight + 48 + "px";
    }
  }, [textAreaRef, value]);

  const isMobile = window.innerWidth <= 600;

  return (
    <>
    <Container>
      <Wrapper onClick={() => textAreaRef.current?.focus()} ref={wrapperRef} positionX={positionX} positionY={positionY}>
        <Input ref={textAreaRef} textAlign={textAlign} maxLength={maxLength} value={value} onChange={onChange} placeholder={placeholder} />
      </Wrapper>
      {!isMobile && (
        <TextLenght>
          <Typography type="paragraphXXS" color="label">{`${t('chars') + " "} ${value.trim().length} ${maxLength ? `/ ${maxLength}` : ""}`}</Typography>
        </TextLenght>
      )}
    </Container>
    {isMobile && (
      <TextLenght>
        <Typography type="paragraphXXS" color="label">{`${t('chars') + " "} ${value.trim().length} ${maxLength ? `/ ${maxLength}` : ""}`}</Typography>
      </TextLenght>
    )}
    </>
  )
}